import { listedOnTools } from './outreach-alfred';

/**
 * The home's "Connected" and "Recommended" connector groups (Home 2's section, the Overview's rail). A row the
 * Tools tab leaves out (`listedOnTools`: a server-hidden row, or Alfred while it is on Outreach) is in neither:
 * each card opens the Tools tab at that connector, and the Tools tab has no card for it.
 * Import-light so it is unit-testable in the node-env suite. Mirrors iOS/Android `HomeFeed.connectorGroups`.
 */
/**
 * Connectors that are alternatives to each other: someone keeps ONE calendar and ONE mailbox, so once any member of
 * a family is connected, recommending its siblings reads as "we didn't notice". They stay on the Connectors screen —
 * only the recommendation is withheld. Mirrors iOS/Android `HomeFeed.alternativeFamilies`.
 */
export const ALTERNATIVE_CONNECTOR_FAMILIES: readonly (readonly string[])[] = [
  ['calendar-google', 'calendar-microsoft', 'calendar-apple'],
  ['gmail', 'outlook'],
];

export function homeConnectorGroups<T extends { toolkit: string; connected: boolean; hiddenFromConnectorsList?: boolean }>(
  connectors: readonly T[],
  alfredOnOutreach: boolean,
): { connected: T[]; recommended: T[] } {
  const listed = connectors.filter((c) => listedOnTools(c, alfredOnOutreach));
  const connected = listed.filter((c) => c.connected);
  const connectedSlugs = new Set(connected.map((c) => c.toolkit));
  const covered = new Set(ALTERNATIVE_CONNECTOR_FAMILIES.filter((family) => family.some((slug) => connectedSlugs.has(slug))).flat());
  return { connected, recommended: listed.filter((c) => !c.connected && !covered.has(c.toolkit)) };
}
